export const MONTU_URL = "https://montu.io";
export const CREATORS_URL = "https://montu.io/creators";
export const TERMS_URL = "https://montu.io/terms-and-conditions";
export const PRIVACY_URL = "https://montu.io/privacy-policy";
